import formUrlEncoded from 'form-urlencoded';
class TradeAreaClient {
    constructor(basePath = window.wpApiSettings.basePath, nonce = window.wpApiSettings.nonce) {
        this.basePath = basePath;
        this.nonce = nonce;
    }
    async dispatch(endpoint, query, method, data) {
        let json;
        if (data !== undefined) {
            json = JSON.stringify(data);
        }
        const res = await fetch(this.basePath + endpoint + '?' + formUrlEncoded(query), {
            method,
            body: json,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-WP-Nonce': this.nonce,
            },
        });
        return await res.json();
    }
    async getWCProductPermalink(id) {
        return await this.dispatch(`esperiri/tradearea/v1/wcProductPermalink/${id}`, {}, 'GET');
    }
    async getProducts(options = {}) {
        options = Object.assign({
            limit: 10,
            offset: 0,
        }, options);
        return await this.dispatch('esperiri/tradearea/v1/products', options, 'GET');
    }
    async getProduct(id) {
        return await this.dispatch(`esperiri/tradearea/v1/products/${id}`, {}, 'GET');
    }
    async getCategories(options = {}) {
        options = Object.assign({
            parent: 0,
        }, options);
        return await this.dispatch('esperiri/tradearea/v1/categories', options, 'GET');
    }
    async getBrands(options = {}) {
        return await this.dispatch('esperiri/tradearea/v1/brands', options, 'GET');
    }
    async getMaterials(options = {}) {
        options = Object.assign({}, options);
        return await this.dispatch('esperiri/tradearea/v1/materials', options, 'GET');
    }
    async getProjects(options = {}) {
        options = Object.assign({
            limit: 10,
            offset: 0,
        }, options);
        return await this.dispatch('esperiri/tradearea/v1/projects', options, 'GET');
    }
    async getProject(id) {
        return await this.dispatch(`esperiri/tradearea/v1/projects/${id}`, {}, 'GET');
    }
    async postProject(project) {
        return await this.dispatch('esperiri/tradearea/v1/projects', {}, 'POST', project);
    }
    async updateProject(id, project) {
        return await this.dispatch(`esperiri/tradearea/v1/projects/${id}`, {}, 'PATCH', project);
    }
}
export const tradeAreaClient = new TradeAreaClient();
